import { configureStore } from "@reduxjs/toolkit";
import userSelectionReducer from "./userSelection";
import profilesReducer from "./profiles";
import unifyReducer from "./unify";

const store = configureStore({
    reducer: {
        userSelection: userSelectionReducer,
        profiles: profilesReducer,
        unify: unifyReducer,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
